<template>
    <div style="height: 480px;">
        <div style="width: 100%;text-align: center;">
            <div style="width:58%;margin:0 auto;margin-bottom: 10px;">
                <p style="text-align: left;font-size: 16px;padding-top: 10px;">账号：{{sta.userId}}</p>
                <p style="text-align: left;font-size: 16px;">手机：{{sta.mobileNum===''?'':sta.mobileNum.replace(sta.mobileNum.substring(3,7),'****')}}</p>
            </div>
            <div class="qrcode-border">
                <div style="position: relative;width: 100%;display: block;padding-top: 5px;">
                    <div id="qrcode" ref="qrcode" style="margin:0 auto;width: 240px;height: 240px;">
                    </div>
                </div>
                <Spin size="large" fix v-if="spinShow" style="width: 245px;height: 250px;"></Spin>
            </div>
        </div>
        <!-- 不展示分销商 -->
        <!-- <div v-show="!isBound" @click="bindDistributor" style="display: block;margin:0 auto;color:#2db7f5;cursor: pointer;width: 100px;margin-top:30px;">绑定分销商</div>
        <div v-show="isBound" style="display: block;margin:0 auto;color:#19be6b;width: 220px;margin-top:30px;">分销商ID：{{jgjid}}<p style="margin-top:0px;color:#2d8cf0;cursor: pointer;" @click="bindDistributor2">分销商操作指引</p>
        </div> -->
        <div style="margin:auto 20%;margin-top:30px;"><Button style="border-radius:15px;box-shadow: none;" long type="primary"  @click="showMyCustomer">我的客户</Button></div>
        
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/'
import QRCode from 'qrcodejs2'
import ConstJson from "../../api/common/constjson.js"
let constJ = new ConstJson()
export default {
    name: 'mypromocode',
    data() {
        return {
            spinShow: true,
            qr_code: '',
            isBound: false,
            jgjid: '',
        }
    },
    computed: {
        ...mapGetters(['sta'])
    },
    created() {
        // this.$nextTick(function() {
        //     this.getQrCodeUrl()
        // })

    },
    methods: {
        showMyCustomer(){
            console.log('show-my-customer====>')
            this.$emit('showCustomer')
            // let args = {
            //     page: 1,
            //     line: 10,
            // }
            // constJ.getCustomer(args).then(res => {
            //     console.log(res)
            //     if (res.rtncode === 1) {
            //         if (res.rltcode === 1) {
                        
            //         }
            //     }
            // })
        },
        bindDistributor() {
            console.log('bind-distributor===>')
            this.$emit('bind-distri',false)
        },
        bindDistributor2() {
            console.log('bind-distributor===>')
            this.$emit('bind-distri',true)
        },
        //getPromoCode
        loadUI() {
            this.spinShow = true
            setTimeout(() => {
                this.getQrCodeUrl()
            }, 500)
        },
        getQrCodeUrl() {
            console.log('getQrCodeUrl====>')
            constJ.getPromoCode().then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (res.result.spreadlink) {
                            this.jgjid = res.result.jgjid
                            this.isBound = res.result.jgjid !== 0 ? true : false
                            this.$nextTick(function() {
                                this.qrCode(res.result.spreadlink)
                            })

                        }
                    }
                }
            })
        },

        qrCode(url) {
            this.$refs.qrcode.innerHTML = "";
            this.qr_code = new QRCode('qrcode', {
                text: '众智云擎',
                width: 240, //图像宽度
                height: 240, //图像高度
                colorDark: "#000000", //前景色
                colorLight: "#ffffff", //背景色
                typeNumber: -1,
                correctLevel: QRCode.CorrectLevel.L //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
            })
            //this.qr_code.clear() //清除二维码 
            this.qr_code.makeCode(url) //生成另一个新的二维码
            //移除mouseover的链接提示
            document.getElementById('qrcode').title = "众智云擎"
            this.spinShow = false
            // setTimeout(() => {
            //     this.spinShow = false
            // }, 500)


        },
    }
}
</script>
<style lang="less" scoped>
#qrcode /deep/ img {
    display: block;
    //border: 1px solid #e2e2e2;
    //padding: 10px;
}
.qrcode-border{
    position: relative;
    display: flex;
    background-color: white;
    width: 250px;
    height: 255px;
    margin:0 auto;
    border:1px solid #dcdee2;
}
</style>